import { render, staticRenderFns } from "./TopEntityComponentCountPlaces.vue?vue&type=template&id=545bf146&"
import script from "./TopEntityComponentCountPlaces.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentCountPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports